import axios from 'axios';
import constants from '../../config/constants';

export const GET_ALL_SCHOLAE_ADMINS = 'GET_ALL_SCHOLAE_ADMINS';
export const GET_SCHOLAE_ADMIN = 'GET_SCHOLAE_ADMIN';

//= ========== Reducer call functions begin ===========//
export const getAllSchoolAdmins = schoolAdminData => ({
  type: GET_ALL_SCHOLAE_ADMINS,
  schoolAdminData,
});

export const getSchoolAdmin = admin => ({
  type: GET_SCHOLAE_ADMIN,
  admin,
});
//= ========== Reducer call functions begin ===========//

//= ========== User routing begin ===========//
export const fetchAllSchoolAdminsService = data => async dispatch => {
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/get-all-school-admin/${data.schoolId}${constants.makeParams(
        data.pageParams
      )}`,
      constants.setHeader(data.token)
    );
    return dispatch(getAllSchoolAdmins(res.data));
  } catch (err) {
    console.error(err.response);
  }
};

export const saveSchoolAdminService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/admin/create-school-admin`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const fetchSchoolAdminService = data => async dispatch => {
  const res = await axios.get(
    `${constants.API_BASE_URL}/api/admin/get-school-admin/${data.schoolAdminId}`,
    constants.setHeader(data.token)
  );
  return dispatch(getSchoolAdmin(res.data));
};

export const updateSchoolAdminService = data => () => {
  return axios.put(
    `${constants.API_BASE_URL}/api/admin/update-school-admin/${data.schoolAdminId}`,
    data.postData,
    constants.setHeader(data.token)
  );
};

export const deleteSchoolAdminService = data => () => {
  return axios.delete(
    `${constants.API_BASE_URL}/api/admin/delete-school-admin/${data.schoolAdminId}`,
    constants.setHeader(data.token)
  );
};
//= ========== User routing end ===========//
